import { Menu, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import {
  ArrowLeftOutlined,
  SettingOutlined,
  UserOutlined,
  LockOutlined,
  BankOutlined,
  ControlOutlined,
  FileDoneOutlined,
  DashboardOutlined,
  TeamOutlined,
  IdcardOutlined,
  AppstoreOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { useSelector } from "react-redux";
import Theme from "../../theme/Theme";
import { useGlobalSettings } from "../../context/GlobalSettingsContext";

const paths = [
  { path: "/settings/user-profile", key: "1" },
  { path: "/settings/change-password", key: "2" },
  { path: "/settings/customization", key: "3" },
  { path: "/settings/business-profile", key: "10" },
  { path: "/settings/general", key: "11" },
  { path: "/settings/general/org-levels", key: "11" },
  { path: "/settings/general/plan-templates", key: "11" },
  { path: "/settings/general/plan-groups", key: "11" },
  { path: "/settings/general/designations", key: "11" },
  { path: "/settings/general/plan-attributes", key: "11" },
  { path: "/settings/general/scales", key: "11" },
  { path: "/settings/general/login-audit", key: "11" },
  { path: "/settings/organization", key: "12" },
  { path: "/settings/unit", key: "12" },
  { path: "/settings/positions", key: "13" },
  { path: "/settings/users", key: "14" },
  { path: "/settings/perf-cycles", key: "15" },
  { path: "/settings/approvals", key: "16" },
  { path: "/settings/target-approvals", key: "17" },
  { path: "/settings/plan-approvals", key: "18" },
];

function SettingsSideMenu(props) {
  const proHeight = document.body.clientHeight;
  const [mainKey, setMainKey] = useState("");
  let curLocation = useLocation();
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;
  const { defaultLandingPage } = useGlobalSettings();

  useEffect(() => {
    setMainKey("");
    paths.forEach((path) => {
      if (path.path === curLocation.pathname) {
        setMainKey(path.key);
      } else if (curLocation.pathname.split("/")[2] === "unit") {
        setMainKey("12");
      } else if (curLocation.pathname.split("/")[3] === "plan-templates") {
        setMainKey("11");
      }
    });
  }, [curLocation]);

  return (
    <>
      <style>
        {`
          .custom-settings-menu .ant-menu-item {
            margin: 4px 8px !important;
            border-radius: 8px !important;
            transition: all 0.3s ease !important;
          }
          
          .custom-settings-menu .ant-menu-item:hover {
            background-color: #D14A1F !important;
            color: white !important;
          }
          
          .custom-settings-menu .ant-menu-item:hover .ant-menu-item-icon {
            color: white !important;
          }
          
          .custom-settings-menu .ant-menu-item:hover a {
            color: white !important;
          }
          
          .custom-settings-menu .ant-menu-item-selected {
            background-color: white !important;
            color: #D14A1F !important;
            border-radius: 8px !important;
          }
          
          .custom-settings-menu .ant-menu-item-selected .ant-menu-item-icon {
            color: #D14A1F !important;
          }
          
          .custom-settings-menu .ant-menu-item-selected a {
            color: #D14A1F !important;
          }
          
          .custom-settings-menu .ant-menu-item-selected::after {
            display: none !important;
          }
        `}
      </style>
      <div className={"mt-6 " + (!props.collapsed && "px-4")} style={{ color: Theme().textPrimary }}>
        <Link to={defaultLandingPage || "/my-plans"} className="hover:opacity-80 text-xs" style={{ color: Theme().textSecondary }}>
          {!props.collapsed ? (
            <div>
              <ArrowLeftOutlined /> Back
            </div>
          ) : (
            <div className="text-center mb-1">
              <ArrowLeftOutlined />
            </div>
          )}
        </Link>
        {props.collapsed ? (
          <div className="text-center">
            <SettingOutlined className="text-xl" style={{ color: Theme().primary }} />
          </div>
        ) : (
          <div className="text-xl pri-font" style={{ color: Theme().textPrimary }}>Settings</div>
        )}
      </div>
      <Menu
        className="transparent-scroll custom-settings-menu"
        style={{
          height: proHeight - 142,
          overflow: "auto",
          marginTop: "20px",
          backgroundColor: Theme().sideMenu,
          color: Theme().textPrimary,
          fontFamily: 'Inter, sans-serif',
          fontWeight: 400,
          paddingLeft: 0,
          paddingRight: 0,
        }}
        theme="light"
        selectedKeys={[mainKey]}
        mode="inline"
      >
        <div
          className={
            "text-xs mt-3 mb-3 " + (props.collapsed ? "text-center" : "pl-6")
          }
          style={{ color: Theme().textPrimary }}
        >
          Pers<span style={{ display: props.collapsed ? "none" : "inline" }}>onal</span>
        </div>
        <Menu.Item key="1" icon={<UserOutlined />}>
          <Link to="/settings/user-profile">Your Profile</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<LockOutlined />}>
          <Link to="/settings/change-password">Change Password</Link>
        </Menu.Item>
        <Menu.Item key="3" icon={<AppstoreOutlined />}>
          <Link to="/settings/customization">Customization</Link>
        </Menu.Item>
        <div
          className={
            "text-xs mt-6 mb-3 " +
            (props.collapsed ? "text-center" : "pl-6")
          }
          style={{ color: Theme().textPrimary }}
        >
          Org
          <span style={{ display: props.collapsed ? "none" : "inline" }}>anization</span>
        </div>
        {permissionAbility(userLevel, "general", "view") && (
          <Menu.Item key="11" icon={<ControlOutlined />}>
            <Link to="/settings/general">General</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "organization", "view") && (
          <Menu.Item key="12" icon={<BankOutlined />}>
            <Link to="/settings/organization">Organization</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "positions", "view") && (
          <Menu.Item key="13" icon={<IdcardOutlined />}>
            <Link to="/settings/positions">Positions</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "users", "view") && (
          <Menu.Item key="14" icon={<TeamOutlined />}>
            <Link to="/settings/users">Users</Link>
          </Menu.Item>
        )}
        {permissionAbility(userLevel, "perf-cycles", "view") && (
          <Menu.Item key="15" icon={<DashboardOutlined />}>
            <Link to="/settings/perf-cycles">Perf cycles</Link>
          </Menu.Item>
        )}
        <Menu.Item key="16" icon={<FileDoneOutlined />}>
          <Link to="/settings/approvals">Approvals</Link>
        </Menu.Item>
        <Menu.Item key="17" icon={<FileDoneOutlined />}>
          <Link to="/settings/target-approvals">Target Approvals</Link>
        </Menu.Item>
        <Menu.Item key="18" icon={<FileDoneOutlined />}>
          <Link to="/settings/plan-approvals">Plans Approvals</Link>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default SettingsSideMenu;
